/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const discountMsg = document.querySelector(".cart__discount span");

    if (discountMsg) {
      // Decode escaped HTML
      const textarea = document.createElement("textarea");
      textarea.innerHTML = discountMsg.innerHTML;
      const decoded = textarea.value;

      discountMsg.innerHTML = decoded;

      // Bold the dollar amount
      const glcSpan = discountMsg.querySelector("span.glc-money");
      if (glcSpan) {
        const amount = glcSpan.textContent;
        const boldedAmount = document.createElement("strong");
        boldedAmount.textContent = amount;
        glcSpan.replaceWith(boldedAmount);
      }

      // Bold the discount code (last word after "with")
      let updatedHTML = discountMsg.innerHTML;
      updatedHTML = updatedHTML.replace(/ with ([A-Z0-9_-]+)/, ' with <strong>$1</strong>');
      discountMsg.innerHTML = updatedHTML;
    }
  });
})();

// Open every Loop returns portal link (menus, pages, buttons) in a new tab
(function () {
  document.addEventListener("click", function (e) {
    var link = e.target.closest && e.target.closest('a[href*="loopreturns.com"]');
    if (!link) return;
    link.setAttribute("target", "_blank");
    link.setAttribute("rel", "noopener");
  }, true);
})();

  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
